<template>
    <header class="titlebar">
        <div class="titlebar__left">
            <button class="btn d-flex align-items-center justify-content-center" style="width: 36px; height: 28px;">
                <i class="bi bi-menu-button-fill" style="font-size: 14px;"></i>
            </button>
            <span class="logo">
                <i class="bi bi-bezier"></i>
            </span>
            <span class="brand">Sheet Creator</span>
            <div class="file">
                <span class="name">{{ projectName }}</span>
                <span class="dot"></span>
                <span class="page">Page 1</span>
            </div>
        </div>
    </header>
</template>

<script>
import { Creator } from '@/lib/visionary/visionary.js';

export default {
    name: 'HeaderComp',
    props: {
        creator: {
            type: Creator,
            required: false,
        },
        projectName: {
            type: String,
            required: false,
            default: "Untitled Design"
        }
    },
    data(){
        return {
            theme: (document.documentElement.getAttribute('data-theme') || 'dark')
        }
    },
    computed: {
        zoom() {
            if( !this.$store.state.editor.saveState ) return 1;

            return this.$store.state.editor.saveState.zoom || 1;
        }
    },
    methods: {
        toggleTheme(){
            this.theme = this.theme === 'dark' ? 'light' : 'dark';
            document.documentElement.setAttribute('data-theme', this.theme);
            try { localStorage.setItem('theme', this.theme); } catch(e) {}
        },
        setZoom(zoom) {
            this.creator.zoom = Math.round((this.creator.zoom + zoom)*10)/10;

            this.creator.refresh();
        }
    }
}
</script>

<style scoped>
.titlebar {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    padding: 0 10px;
    background: var(--titlebar);
    border-bottom: 1px solid var(--border);
    -webkit-app-region: drag;
}
.titlebar__left, .titlebar__center, .titlebar__right { display: flex; align-items: center; }
.titlebar__left { gap: 10px; margin-left: 0px; }
.logo { display: inline-grid; place-items: center; width: 28px; height: 28px; background: var(--border); border-radius: 50%; border: 1px solid var(--accent) }
.brand { font-weight: 600; }
.file { display: flex; align-items: center; gap: 8px; color: var(--muted); font-size: 12px; }
.file .dot { width: 4px; height: 4px; background: var(--muted); border-radius: 50%; display: inline-block; }
.titlebar__center { justify-content: center; }
.btn { height: 28px; padding: 0 10px; border-radius: 6px; border: 1px solid var(--border); background: var(--panel-2); color: var(--text); font-size: 12px; cursor: pointer; }
.zoom { display: flex; gap: 8px; align-items: center; }
.zoom__value { width: 56px; text-align: center; color: var(--muted); font-size: 12px; }
.btn.ghost { background: transparent; }
.titlebar__right { justify-content: flex-end; gap: 8px; }
.btn.primary { background: var(--accent); border-color: var(--accent); color: white; }

.no-drag { -webkit-app-region: no-drag; }
</style>
